import { fetchConToken } from '../utils/fetch.ts';

/**
 * Verifica si un alumno necesita aceptar el convenio de una gira
 * @param {number} aluId - ID del alumno
 * @param {number} girId - ID de la gira
 * @returns {Promise}
 */
export const verificarConvenio = async (aluId: number, girId: number) => {
  try {
    const response = await fetchConToken(`convenios/verificar/${aluId}/${girId}`, {}, 'GET');
    const body = await response.json();
    return body;
  } catch (error) {
    console.error('Error al verificar convenio:', error);
    throw error;
  }
};

/**
 * Genera el PDF del convenio para un alumno y gira
 * @param {number} aluId - ID del alumno
 * @param {number} girId - ID de la gira
 * @returns {Promise}
 */
export const generarConvenio = async (aluId: number, girId: number) => {
  try {
    const response = await fetchConToken(`convenios/generar/${aluId}/${girId}`, {}, 'GET');
    const body = await response.json();
    return body;
  } catch (error) {
    console.error('Error al generar convenio:', error);
    throw error;
  }
};

/**
 * Obtiene la URL para descargar/previsualizar el convenio
 * @param {number} aluId - ID del alumno
 * @param {number} girId - ID de la gira
 * @returns {string} URL del PDF
 */
export const getConvenioUrl = (aluId: number, girId: number): string => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
  const token = localStorage.getItem('token');
  return `${baseUrl}/convenios/descargar/${aluId}/${girId}?token=${token}`;
};

/**
 * Registra la aceptación del convenio
 * @param {number} aluId - ID del alumno
 * @param {number} girId - ID de la gira
 * @returns {Promise}
 */
export const aceptarConvenio = async (aluId: number, girId: number) => {
  try {
    const response = await fetchConToken('convenios/aceptar', {
      alu_id: aluId,
      gir_id: girId
    }, 'POST');
    const body = await response.json();
    return body;
  } catch (error) {
    console.error('Error al aceptar convenio:', error);
    throw error;
  }
};

/**
 * Obtiene todos los convenios de una gira (para administrador)
 * @param {number} girId - ID de la gira
 * @returns {Promise}
 */
export const obtenerConveniosGira = async (girId: number) => {
  try {
    const response = await fetchConToken(`convenios/gira/${girId}`, {}, 'GET');
    const body = await response.json();
    return body;
  } catch (error) {
    console.error('Error al obtener convenios de la gira:', error);
    throw error;
  }
};
